import BaseComponent from '../../js/base-component';

export default class CookiesComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.container = this.refs.container;
        this.buttonReject = this.refs.reject;
        this.buttonAccept = this.refs.accept;
        this.buttonToggle = this.refs.toggle;
        this.HiddenClass = 'is-hidden';
        this.OpenedClass = 'is-opened';

        this.onButtonRejectClick = this.onButtonRejectClick.bind(this);
        this.onButtonAcceptClick = this.onButtonAcceptClick.bind(this);
        this.onButtonToggleClick = this.onButtonToggleClick.bind(this);
    }

    static getRequiredRefs(){
        return ['container', 'reject', 'accept', 'toggle'];
    }

    init(){
        this.buttonReject.addEventListener('click', this.onButtonRejectClick);
        this.buttonAccept.addEventListener('click', this.onButtonAcceptClick);
        this.buttonToggle.addEventListener('click', this.onButtonToggleClick);
    }

    onButtonRejectClick(e){
        document.cookie = 'ct_reject_cookie=1; expires=365;';
        this.element.classList.remove(this.OpenedClass);
        this.element.classList.add(this.HiddenClass);
        this.element.remove();
    }

    onButtonAcceptClick(e){
        document.cookie = 'ct_apply_cookie=1; expires=365;';
        this.element.classList.remove(this.OpenedClass);
        this.element.classList.add(this.HiddenClass);
        this.element.remove();
    }

    onButtonToggleClick(e){
        this.element.classList.toggle(this.OpenedClass);
    }

    onDestroy(){
        this.buttonReject.removeEventListener('click', this.onButtonRejectClick);
        this.buttonAccept.removeEventListener('click', this.onButtonAcceptClick);
        this.buttonToggle.removeEventListener('click', this.onButtonToggleClick);
    }
}
